console.log('[Theme] Script Initialized');

// 1) CustomEvent listener (one we tried before)
window.addEventListener('shopify:pixel:my_pixel', (e) => {
  const name = e && e.detail && e.detail.name;
  console.log('[Theme] Event received (CustomEvent):', name);
});

// 2) postMessage listener (cross-realm / iframe-safe)
window.addEventListener('message', (e) => {
  // only accept same-origin messages from our page
  if (e.origin !== window.location.origin) return;
  const data = e.data || {};
  if (data && data.source === 'my_pixel') {
    console.log('[Theme] Event received (postMessage):', data.name);
  }
});

// 3) Drain any queued events that happened before this script loaded
try {
  if (Array.isArray(window.__MY_PIXEL_EVENTS) && window.__MY_PIXEL_EVENTS.length) {
    window.__MY_PIXEL_EVENTS.forEach(ev => {
      console.log('[Theme] Event received (queue):', ev.name);
    });
    // optional: clear queue after reading
    // window.__MY_PIXEL_EVENTS.length = 0;
  }
} catch (err) {
  console.warn('[Theme] Queue read failed:', err);
}
